/**
 * ActionNames
 */
export const SET_TARGET_UNIT = "GROUP_HOME/SET_TARGET_UNIT";
